// General
import React, { useState, useContext } from "react";
// Styles
import { Modal } from "react-bootstrap";
import { TextField, Autocomplete, Button, Card, InputAdornment, IconButton } from "@mui/material";
// Formik
import { Formik, Form, Field } from "formik";
// Icons
import DeleteIcon from "@mui/icons-material/Delete";
// Contexts
import { ServiceContext } from "../../data/services/ServiceContext";
import { CustomerContext } from "../../data/customer/CustomerContext";
import { OfferContext } from "../../data/offer/OfferContext";
// Modals
import CustomerAddModal from "../customer/CustomerAddModal";
// Validations
import { useValidations } from "../../data/ValidationContext";

function OfferAddModal({ show, handleClose }) {
  const { addOffer } = useContext(OfferContext);
  const { services } = useContext(ServiceContext);
  const { customers, addCustomer } = useContext(CustomerContext);

  const [showCustomerModal, setShowCustomerModal] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [selectedServices, setSelectedServices] = useState([]);
  //Validation 
  const { vs_offer } = useValidations();

  const initialValues = {
    vatRate: 18,
    plannedDate: "",
    note: "",
    fullName: "",
    phone1: "",
    phone2: "",
    email: "",
    customerType: "Bireysel",
    tcNo: "",
    vergiNo: "",
    vergiDairesi: "",
    city: "",
    district: "",
    address: "",
  };

  const handleAddEmptyService = () => {
    setSelectedServices((prev) => [
      ...prev,
      { id: Date.now(), name: "", quantity: 1, price: 0 },
    ]);
  };

  const handleRemoveService = (id) => {
    setSelectedServices((prev) => prev.filter((s) => s.id !== id));
  };

  const calculateTotal = (vatRate) => {
    const subtotal = selectedServices.reduce(
      (sum, s) => sum + s.quantity * s.price,
      0
    );
    return subtotal + (subtotal * vatRate) / 100;
  };
//HTML
  return (
    <>
      <Modal show={show} onHide={handleClose} size="xl" centered>
        <Formik
          enableReinitialize
          initialValues={{ ...initialValues, selectedServices }}
          validationSchema={vs_offer}
          onSubmit={(values) => {
            if (!selectedCustomer && !values.fullName) return;

            let customerId;
            if (selectedCustomer) {
              customerId = selectedCustomer.id;
            } else {
              const newCustomer = {
                fullName: values.fullName,
                phone1: values.phone1,
                phone2: values.phone2,
                email: values.email,
                customerType: values.customerType,
                tcNo: values.tcNo,
                vergiNo: values.vergiNo,
                vergiDairesi: values.vergiDairesi,
                city: values.city,
                district: values.district,
                address: values.address,
              };
              addCustomer(newCustomer);
              customerId = customers.length + 1;
            }

            const newOffer = {
              customerId,
              offerDate: new Date().toISOString().split("T")[0],
              plannedDate: values.plannedDate,
              vatRate: values.vatRate,
              note: values.note,
              items: selectedServices,
            };

            addOffer(newOffer);
            handleClose();
          }}
        >
          {({ values, handleChange, setFieldValue, touched, errors }) => (
            <Form>
              <Modal.Header closeButton>
                <Modal.Title>Teklif Oluştur</Modal.Title>
              </Modal.Header>

              <Modal.Body>
                <div className="d-flex flex-column flex-lg-row gap-4">
                 {/* SOL: Müşteri Bilgileri */}
                  <div style={{ flex: 0.4 , maxHeight:400 }}>
                    <h5>Müşteri Bilgileri</h5>

                    {/* Kayıtlı Müşteri Seçme */}
                    <div className="d-flex gap-1 my-2" style={{ alignItems: "center" }}>
                      <Autocomplete
                        options={customers}
                        getOptionLabel={(c) => c.fullName}
                        value={selectedCustomer}
                        onChange={(_, newValue) => {
                          setSelectedCustomer(newValue);
                          if (newValue) {
                            Object.keys(values).forEach((key) => {
                              if (newValue[key] !== undefined) setFieldValue(key, newValue[key]);
                            });
                          }
                        }}
                        sx={{ flex: 1 }}
                        renderInput={(params) => (
                          <TextField {...params} label="Kayıtlı Müşteri Seç" size="small" />
                        )}
                      />
                      <Button
                        variant="contained"
                        size="small"
                        onClick={() => setShowCustomerModal(true)}
                      >
                        Ekle
                      </Button>
                    </div>

                    {/* Servis Seçimi */}
                    <Autocomplete
                      options={services.filter(
                        (s) => !selectedCustomer || s.customerId === selectedCustomer.id
                      )}
                      getOptionLabel={(s) =>
                        `${s.brand} ${s.device} ${s.deviceModel || ""}`.trim()
                      }
                      value={selectedServices[0] || null}
                      onChange={(_, selected) => {
                        if (selected) {
                          const newServices = [
                            { ...selected, quantity: 1, price: selected.price || 0 },
                          ];
                          setSelectedServices(newServices);
                          setFieldValue("selectedServices", newServices);
                        } else {
                          setSelectedServices([]);
                          setFieldValue("selectedServices", []);
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Servis Seç"
                          placeholder="Servisi seçin"
                          size="small"
                          className="my-2"
                          error={Boolean(
                            touched.selectedServices && errors.selectedServices
                          )}
                          helperText={
                            touched.selectedServices && typeof errors.selectedServices === "string"
                              ? errors.selectedServices
                              : ""
                          }
                        />
                      )}
                    />

                    <Field
                      as={TextField}
                      type="date"
                      label="Planlanan Teslim Tarihi"
                      name="plannedDate"
                      size="small"
                      fullWidth
                      value={values.plannedDate}
                      onChange={handleChange}
                      InputLabelProps={{ shrink: true }}
                      error={touched.plannedDate && Boolean(errors.plannedDate)}
                      helperText={touched.plannedDate && errors.plannedDate}
                      className="my-2"

                    />
                    <Field
                      as={TextField}
                      name="note"
                      label="Ek Not"
                      size="small"
                      fullWidth
                      multiline
                      rows={3}
                      className="my-2"
                    />

                    <div className="d-flex gap-2 my-2">

                      <TextField
                        label="KDV’siz Toplam"
                        value={calculateTotal(0).toFixed(2)}
                        size="small"
                        InputProps={{
                          readOnly: true,
                          endAdornment: <InputAdornment position="end">₺</InputAdornment>,
                        }}
                        style={{ flex: 1 }}
                      />
                      <TextField
                        label="KDV (%)"
                        name="vatRate"
                        type="number"
                        size="small"
                        value={values.vatRate}
                        onChange={handleChange}
                        InputProps={{
                          endAdornment: <InputAdornment position="end">%</InputAdornment>,
                        }}
                        style={{ flex: 1 }}
                      />
                      <TextField
                        label="KDV’li Toplam"
                        value={calculateTotal(values.vatRate).toFixed(2)}
                        size="small"
                        InputProps={{
                          readOnly: true,
                          endAdornment: <InputAdornment position="end">₺</InputAdornment>,
                        }}
                        style={{ flex: 1 }}
                      />
                    </div>
                  </div>

                  {/* SAĞ: Servis / Teklif Detayları */}
                  <div style={{ flex: 0.6 }}>
                    <h5 className="d-flex justify-content-between align-items-center">
                      Servis / Teklif Detayları
                      <Button
                        variant="contained"
                        size="small"
                        onClick={handleAddEmptyService}
                      >
                        Kalem Ekle
                      </Button>
                    </h5>

                    <Card variant="outlined" style={{ maxHeight: 305, overflowY: "auto", padding: 10 }}>
                      {selectedServices.map((s, index) => (
                        <div key={s.id} className="d-flex flex-column flex-md-row gap-2 my-2">
                          <TextField
                            value={s.name}
                            onChange={(e) => {
                              s.name = e.target.value;
                              setSelectedServices([...selectedServices]);
                              setFieldValue(`selectedServices[${index}].name`, e.target.value);
                            }}
                            size="small"
                            fullWidth
                            error={Boolean(errors.selectedServices?.[index]?.name)}
                            helperText={errors.selectedServices?.[index]?.name}
                          />
                           <div className="d-flex gap-2 mt-1 flex-md-row flex-row">
                            
                          <TextField
                            label="Adet"
                            type="number"
                            size="small"
                            value={s.quantity}
                            onChange={(e) => {
                              s.quantity = Number(e.target.value);
                              setSelectedServices([...selectedServices]);
                              setFieldValue(`selectedServices[${index}].quantity`, Number(e.target.value));
                            }}
                            style={{ width: 80 }}
                            error={Boolean(errors.selectedServices?.[index]?.quantity)}
                            helperText={errors.selectedServices?.[index]?.quantity}
                          />
                          <TextField
                            label="Fiyat"
                            size="small"
                            value={s.price}
                            onChange={(e) => {
                              s.price = Number(e.target.value);
                              setFieldValue(`selectedServices[${index}].price`, Number(e.target.value));
                              setSelectedServices([...selectedServices]);
                            }}
                            InputProps={{ startAdornment: <InputAdornment position="start">₺</InputAdornment> }}
                            style={{ width: 120 }}
                            error={Boolean(errors.selectedServices?.[index]?.price)}
                            helperText={errors.selectedServices?.[index]?.price}

                          />
                          <IconButton
                            color="error"
                            size="small"
                            onClick={() => handleRemoveService(s.id)}
                          >
                            <DeleteIcon />
                          </IconButton>
                          </div>
                        </div>
                      ))}
                      {touched.selectedServices && typeof errors.selectedServices === "string" && (
                        <div style={{ color: "red", fontSize: 12 }}>{errors.selectedServices}</div>
                      )}
                    </Card>
                  </div>
                </div>
              </Modal.Body>

              <Modal.Footer>
                <button type="button" className="btn btn-secondary" onClick={handleClose}>
                  İptal
                </button>
                <button type="submit" className="btn btn-primary">
                  Kaydet
                </button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>

      <CustomerAddModal
        show={showCustomerModal}
        handleClose={() => setShowCustomerModal(false)}
      />
    </>
  );
}

export default OfferAddModal;
